import ReactModal from "react-modal";
import cx from "classnames";

import "./Modal.scss";
import { Card } from "../Card";
import { Flex } from "../Flex";
import { Button } from "../Button";

type ModalPropTypes = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  renderContent: () => React.ReactNode;
  renderFooter?: () => React.ReactNode;
  className?: string;
};

const Modal = ({
  isOpen,
  onClose,
  title,
  renderContent,
  renderFooter,
  className,
}: ModalPropTypes) => {
  const classes = cx("Modal", className);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose} // Add this line
      className={{
        base: classes,
        afterOpen: "Modal--afterOpen",
        beforeClose: "Modal--beforeClose",
      }}
      overlayClassName={{
        base: "Modal__Overlay",
        afterOpen: "Modal__Overlay--afterOpen",
        beforeClose: "Modal__Overlay--beforeClose",
      }}
      closeTimeoutMS={300}
      ariaHideApp={false}
    >
      <Card className="Modal__Wrapper">
        <Flex className="Modal__Header" justify="space-between" align="center">
          <div className="Modal__Header__Title">{title}</div>
          <Button iconName="X" variant="outline" size="sm" onClick={onClose} />
        </Flex>
        <div className="Modal__Content">{renderContent()}</div>
        {renderFooter && (
          <Flex className="Modal__Footer">{renderFooter()}</Flex>
        )}
      </Card>
    </ReactModal>
  );
};

export { Modal };
